export default "__VITE_ASSET__BmaplQqz__"